$('table').wrap('<div class="table-responsive"></div>');
